import LocalStorageService from "../services/localStorage";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var getHeader = function () {
    return {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        "x-no-cache": "true",
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeaderUpload = function () {
    return {
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeader2 = function (contentType) {
    return {
        "Content-Type": "application/".concat(contentType),
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ip: "123456789",
        "X-Client-Id": lsLogin.getUserLoginStored().clientId,
        Authorization: "Bearer " + lsLogin.getUserLoginStored().token,
    };
};
export var getHeaderLogin = function () {
    return {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        ip: "123456789",
    };
};
